/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import { ModeloNegocioType } from "models/modelo_negocio_type";
import { UsuarioModel } from "models/user_model";
import moment from "moment";
import { useEffect, useRef, useState } from "react";

const useBussinesModel =() => {
    const [modeloNegocio, setModeloNegocio] = useState<ModeloNegocioType[]>([]);
    const [usuario, setUsuario] = useState<UsuarioModel>();
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [error, setError] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [accountSelected, setAccountSelected] = useState<ModeloNegocioType>(null);
    const [nome, setNome] = useState("");
    const [data, setData]  = useState(moment().format("DD/MM/YYYY"));
    const [validade, setValidade]  = useState(moment().add({year : 1}).format("DD/MM/YYYY"));
    const [descricao, setDescricao]  = useState("");
    const [metaFaturamento, setMetaFaturamento]  = useState("");
    const [metaLucro, setMetaLucro]  = useState("");
    const [custoFixo, setCustoFixo]  = useState("");
    const [custoVenda, setCustoVenda]  = useState("");
    const [imposto, setImposto]  = useState("");
    const [desconto, setDesconto]  = useState("");

    const [errorTitle, setErrorTitle] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const cancelRef = useRef();

    const closeError = () => {
      setError(false);
    };

    const changeInput = (tipo: string, value: string) => {
      switch (tipo) {
        case "nome":
          setNome(value);
          break;
        case "data":
          setData(value);
          break;
        case "validade":
          setValidade(value);
          break;  
        case "descricao":
          setDescricao(value);
          break;  
        case "metaFaturamento":
          setMetaFaturamento(value);
          break;
        case "metaLucro":
          setMetaLucro(value);
          break;
        case "custoFixo":
          setCustoFixo(value);
          break;  
        case "custoVenda":
          setCustoVenda(value);
          break;  
        case "imposto":
          setImposto(value);
          break;  
        case "desconto":
          setDesconto(value);
          break;          
        default:
          break;
      }
    }


  const showError = (title: string, msg: string) => {
    setError(true);
    setErrorTitle(title);
    setErrorMsg(msg);
  };

    const cleanInput = () => {
      setNome("")
      setData("")
      setValidade("")
      setDescricao("")
      setMetaFaturamento("")
      setMetaLucro("")
      setCustoFixo("")
      setCustoVenda("")
      setImposto("")
      setDesconto("")
    }
    const add = () => {
      showModal(true);
    };
  
    const edit = (item: ModeloNegocioType) => {
      showModal(true);
      setAccountSelected(item);
      setNome(item.nome);
      setData(moment(item.dataCriacao).format("DD/MM/YYYY"))
      setValidade(moment(item.validade).format("DD/MM/YYYY"))
      setDescricao(item.descricao)
      setMetaFaturamento(Number(item.metaFaturamento).toFixed(2))
      setMetaLucro(Number(item.metaLucro).toFixed(2))
      setCustoFixo(Number(item.custoFixo).toFixed(2))
      setCustoVenda(Number(item.custoVenda).toFixed(2))
      setImposto(Number(item.imposto).toFixed(2))
      setDesconto(Number(item.desconto).toFixed(2))
  
    };
  
    const showModal = (show: boolean) => {
      setShow(show);
      setError(false);
      if(!show) {
        setAccountSelected(null);
      }
    };

    const validate = () => {


      if(nome === ""){
        showError("Erro!", "Preencha Corretamente o campo nome");
        return false;
      }
      if(validade === ""){
        showError("Erro!", "Preencha Corretamente o campo validade");
        return false;
      }
      if(descricao === ""){
        showError("Erro!", "Preencha Corretamente o campo descrição");
        return false;
      }
      if (metaFaturamento === "" || Number(metaFaturamento) < 0 || isNaN(Number(metaFaturamento))) {
        showError("Erro!", "Preencha corretamente o campo meta de faturamento");
        return false;
      }
      if (metaLucro === "" || Number(metaLucro) <= 0 || isNaN(Number(metaLucro))) {
        showError("Erro!", "Preencha corretamente o campo meta de lucro");
        return false;
      }
      if (custoFixo === "" || Number(custoFixo) <= 0 || isNaN(Number(custoFixo))) {
        showError("Erro!", "Preencha corretamente o campo custo fixo");
        return false;
      }
      if (custoVenda === "" || Number(custoVenda) <= 0 || isNaN(Number(custoVenda))) {
        showError("Erro!", "Preencha corretamente o campo custo venda");
        return false;
      }
      if (imposto === "" || Number(imposto) < 0 || isNaN(Number(imposto))) {
        showError("Erro!", "Preencha corretamente o campo imposto");
        return false;
      }
      if (desconto === "" || Number(desconto) < 0 || isNaN(Number(desconto))) {
        showError("Erro!", "Preencha corretamente o campo desconto");
        return false;
      }

      return true;
    }
  
    const save = async () => {

      if(validate()) {
        if (!accountSelected) {
          await addRegister();
         } else {
           await updateRegister();
         }
         await loadData();
      }

    };

    const formataData = (data : string) => {

      const item =  data.split("/");
      const dia = item[0];
      const mes =  item[1];
      const ano =  item[2];
      const dataFormatada = `${ano}-${mes}-${dia}`;
      return dataFormatada;

    };
  
    const addRegister = async () => {

      const valid = formataData(validade);
      const criacao = formataData(data);

      const obj = {
        nome: nome,
        idEmpresa: usuario.idEmpresa,
        custoFixo: Number(custoFixo),
        custoVenda: Number(custoVenda),
        dataCriacao:  new Date(criacao),
        desconto:  Number(desconto),
        descricao: descricao,
        imposto:  Number(imposto),
        metaFaturamento:  Number(metaFaturamento),
        metaLucro: Number(metaLucro),
        validade: new Date(valid)

      };
      const response = await axios.post(process.env.REACT_APP_API_URL + "/modelo-negocio", obj)
          if (response.data === true) {
            setLoading((prev) => (prev = false));
            showModal(false);
            setAccountSelected(null);
            cleanInput();
          }

    };
  
    const updateRegister = async () => {

      const valid = formataData(validade);
      const criacao = formataData(data);

      const obj = {
        id: accountSelected.id,
        nome: nome,
        idEmpresa: usuario.idEmpresa,
        custoFixo: Number(custoFixo),
        custoVenda: Number(custoVenda),
        dataCriacao:  new Date(criacao),
        desconto:  Number(desconto),
        descricao: descricao,
        imposto:  Number(imposto),
        metaFaturamento:  Number(metaFaturamento),
        metaLucro: Number(metaLucro),
        validade: new Date(valid)

      };

      const response = await axios.patch(process.env.REACT_APP_API_URL + "/modelo-negocio/" + accountSelected.id, obj)

          if (response.data === true) {
            setLoading((prev) => (prev = false));
            showModal(false);
            cleanInput()
            setAccountSelected(null);
          }
    }
  
    const showDeleteModal = (item: ModeloNegocioType ) => {
      setShowDelete(true);
      setAccountSelected(item);
  
    }
  
    const closeDelete = () => {
      setShowDelete(false);
    }
  
    const deletar = async () => {
      const response = await axios.delete(process.env.REACT_APP_API_URL + "/modelo-negocio/" + accountSelected?.id)
      if (response.data === true) {
        setLoading((prev) => (prev = false));
        showModal(false);
        cleanInput()
        setAccountSelected(null);
        setShowDelete(false);
        await loadData();
      }
    }

    const loadData = async () => {
      const userData = JSON.parse(localStorage.getItem("user"));
      setUsuario(userData);

      const response = await axios.get(process.env.REACT_APP_API_URL + "/modelo-negocio/list/" + userData?.idEmpresa)
      if(response.data) {
            setLoading((prev) => (prev = false));
            setModeloNegocio(response.data);
      }
    };
  
    useEffect(() => {
  
     loadData();
    }, []);
  
    return {
      modeloNegocio,
      add,
      edit,
      loading,
      show,
      showModal,
      accountSelected,
      error,
      save,
      deletar,
      showDeleteModal,
      showDelete,
      cancelRef,
      closeDelete,
      changeInput,
      errorTitle,
      errorMsg,
      closeError,
      showError
    };
  };
  
  export default useBussinesModel;
  
